import * as yup from 'yup';
import { createFormStore } from './core/createFormStore';
import { LocalStorageTypes } from '@/common/service/storage';

export type ContactInfo = {
    first_name: string;
    last_name: string;
    email: string;
    phone: string;
    phone2: string;
    send_sms: boolean;
    userId: string | null;
};

export const contactSchema = yup.object({
    first_name: yup.string().min(2).required('First name is required'),
    last_name: yup.string().min(2).required('Last name is required'),
    email: yup.string().email('Email is not valid').required('Email is required'),
    phone: yup
        .string()
        .matches(/^\+\d{1,15}$/, 'Invalid phone number')
        .test('min-length', 'Phone too short', (value) => (value ? value.length >= 12 : false))
        .required('Phone is required'),
    phone2: yup.string().nullable().notRequired(),
});

export const useContactInfo = createFormStore<ContactInfo>({
    initialValues: {
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        phone2: '',
        send_sms: true,
        userId: null,
    },
    schema: contactSchema,
    validateOnChange: true,
    validateOnBlur: true,
    debounceMs: 500,
    localStorageName: LocalStorageTypes.LS_CONTACT_INFO,
});

export type ContactInfoFormState = ReturnType<typeof useContactInfo.getState>;
